export default {
  home: '/',
  aboutBasics: '/about',
  aboutFaq: '/about/faq',
  theBasics: '/about/basics',
  roadmapToCollege: '/roadmapToCollege',
  endorsements: '/endorsements',
  artsHumanities: '/endorsements/artshumanities',
  publicService: '/endorsements/publicservice',
  businessIndustry: '/endorsements/businessindustry',
  multidisciplinary: '/endorsements/multidisciplinary',
  stem: '/endorsements/stem',
  artsHumanitiesCareers: '/careers/artshumanities',
  publicServiceCareers: '/careers/publicservice',
  businessIndustryCareers: '/careers/businessindustry',
  multidisciplinaryCareers: '/careers/multidisciplinary',
  stemCareers: '/careers/stem',
  takeTheQuiz: '/takethequiz',
  findYourPath: '/findyourpath',
  gradPlanner: '/gradplanner',
  emailValidated: '/email-validated',
  maintenance: '/maintenance'
}



// WEBPACK FOOTER //
// ./src/routes/root/routes.js